/**
 * Determines if cell content is predominantly numeric.
 * Used to right-align numeric cells in markdown tables.
 * 
 * Matches: $1,234.56, 12.5%, 1,000, -5.2%, €100, £50, ¥1000, N/A, —, etc.
 * Returns true when >50% of non-whitespace characters are numeric/currency/percentage.
 */
export function isNumericContent(text) {
  if (!text || typeof text !== 'string') return false;

  const trimmed = text.trim();
  if (!trimmed) return false;

  // Common non-numeric placeholders that appear in numeric columns
  if (/^(N\/A|n\/a|—|–|-|TBD|\?)$/.test(trimmed)) return true;

  // Remove whitespace for character analysis
  const stripped = trimmed.replace(/\s/g, '');
  if (!stripped) return false;

  // Count characters that are "numeric-like"
  // Digits, currency symbols, percentage, commas in numbers, decimal points, +/- signs, parentheses (for negative)
  const numericChars = stripped.replace(/[0-9$€£¥%,.+\-()×x]/g, '');
  const numericRatio = 1 - (numericChars.length / stripped.length);

  return numericRatio > 0.5;
}
